

export enum AplosFileLineage {

    Original = "original",
    Derived = "derived",
    Cleaned = "cleaned"

}